import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, BookOpen, FolderTree, ShoppingBag, IndianRupee, Wallet, Image, Star, UserPlus, FileText, ScrollText, ShieldCheck, Settings, Building2, Repeat, Briefcase } from "lucide-react";

const allNav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, module: "reports" },
  { to: "/admin/users", label: "Users", icon: Users, module: "users" },
  { to: "/admin/courses", label: "Course Approvals", icon: BookOpen, module: "courses" },
  { to: "/admin/manage-courses", label: "Manage Courses", icon: BookOpen, module: "courses" },
  { to: "/admin/categories", label: "Categories", icon: FolderTree, module: "categories" },
  { to: "/admin/products", label: "Store Products", icon: ShoppingBag, module: "products" },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag, module: "orders" },
  { to: "/admin/commissions", label: "Commissions", icon: IndianRupee, module: "commissions" },
  { to: "/admin/withdrawals", label: "Withdrawals", icon: Wallet, module: "withdrawals" },
  { to: "/admin/franchise", label: "Institute Franchise", icon: Building2, module: "users" },
  { to: "/admin/educator-plans", label: "Educator Plans", icon: Repeat, module: "users" },
  { to: "/admin/internships", label: "Internships", icon: Briefcase, module: "users" },
  { to: "/admin/test-series", label: "Test Series", icon: FileText, module: "tests" },
  { to: "/admin/banners", label: "Banners & Sliders", icon: Image, module: "banners" },
  { to: "/admin/reviews", label: "Reviews", icon: Star, module: "reviews" },
  { to: "/admin/leads", label: "Leads", icon: UserPlus, module: "leads" },
  { to: "/admin/cms", label: "CMS Pages", icon: FileText, module: "cms" },
  { to: "/admin/roles", label: "Roles & Permissions", icon: ShieldCheck, module: "roles" },
  { to: "/admin/logs", label: "Audit Logs", icon: ScrollText, module: "logs" },
  { to: "/admin/settings", label: "Settings", icon: Settings, module: "settings" },
];

export default function AdminLayout() {
  const { can } = useAuth();
  const nav = allNav.filter((n) => can(n.module, "view"));
  return <DashboardLayout nav={nav} title="Admin Panel" />;
}
